import Breadcrumbs from "@/components/breadcrumb";
import { Layout } from "@/components/layout";
import Container from "@/components/ui/container";
import { Separator } from "@/components/ui/separator";
import { Carousel, CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import React, { useEffect, useState } from "react";
import Image from "next/image";
// à supprimer
import illuRadio1999 from "@/public/radio-1999.jpg";
import illuRadio2010 from "@/public/radio-2010.jpg";

import rrb1985 from "@/public/rrb-1985.png";
import rrbChirac from "@/public/rrb-chirac.png";
import rrbLafleur from "@/public/rrb-lafleur-1998.png";
import rrb1999 from "@/public/rrb-1999.png";
import { SocialShare } from "@/components/socialShare";
import { HeadMetadata } from "@/components/headMetadata";
import { EquipeSlider } from "@/components/equipe";
import { getTeamMembers } from "@/lib/drupalFetcher";
import { DrupalNode } from "next-drupal/dist/types";
import { GetStaticPropsResult } from "next/types";


interface IndexPageProps {
  teamMembers: DrupalNode[]
}
export default function RadioPage({ teamMembers }: IndexPageProps) {
  const [api, setApi] = useState<CarouselApi>();
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    if (!api) {
      return;
    }

    api.on("select", () => {
      if (!api) return;
      setIsStart(!api.canScrollPrev());
      setIsEnd(!api.canScrollNext());
    });
  }, [api]);
  const breadcrumb = [
    { label: 'L\'histoire de la radio' }
  ];

  const node = {
    id: '',
    type: '',
    langcode: '',
    status: true,
    drupal_internal__nid: 9999,
    drupal_internal__vid: 9999,
    changed: '',
    created: '',
    title: '',
    default_langcode: true,
    sticky: false,
    path: {
      alias: '/histoire-de-la-radio',
      pid: 9999,
      langcode: ''
    }
  }

  const storyContents = [
    {
      label: '1985',
      content:
        '<p class="text-lg"><strong>RRB est née en 1985, lorsque les évènements faisaient vaciller l\'espoir des populations</strong> avec pour vocation de donner une voix à la majorité des calédoniens partisans du maintien de la Calédonie dans la France, qui ne disposaient d\'aucun moyen de communication.</p>' +
        '<p class="mt-3 text-base">Son premier journal d\'information a eu lieu le 3 mars 1985 et le succès a été immédiat. RRB est très vite devenue un média incontournable de la Nouvelle-Calédonie, par son professionnalisme, sa présence sur le terrain et sa ligne éditoriale.\n</p>',
      img: rrb1985.src
    },
    {
      label: '1988',
      content:
        '<p class="text-lg"><strong class="text-lg">Acteur engagé de l\'histoire contemporaine de la Nouvelle-Calédonie</strong>, Radio Rythme Bleu est toujours restée fidèle à la défense du maintien de la Calédonie dans la France.</p>' +
        '<p class="mt-3 text-base">Radio militante à sa création, elle s\'est engagée résolument, dès 1988, dans le processus né des accords de Matignon, pour porter la réconciliation, et les notions de partage et de rééquilibrage.</p>',
      img: rrbChirac.src
    },
    {
      label: '1998',
      content:
        '<p class="text-lg"><strong class="text-lg">10 ans plus tard, en 1998</strong>, RRB s\'inscrit dans l\'esprit de l\'Accord de Nouméa, pour un avenir réconcilié et consensuel de la Nouvelle-Calédonie.</p>' +
        '<p class="mt-3 text-base">La radio suit de très près l\'évolution politique et institutionnelle du territoire en étant présente à tous les comités des signataires de l\'Accord de Nouméa et en recevant toutes les personnalités qui font l\'actualité.</p>' +
        '<p class="mt-3 text-base">Engagée, plus que jamais, en faveur du maintien de la Calédonie dans la France, elle est très pluraliste et profondément enracinée localement, parfaitement intégrée régionalement, Radio Rythme Bleu assure, aussi, une vraie continuité nationale avec la métropole, grâce à une convention avec Europe 1, qui participe à l\'enrichissement de ses programmes et notamment de ses rendez-vous d\'information.</p>',
      img: rrbLafleur.src
    },
    {
      label: '1999',
      content:
        '<p class="text-lg"><strong class="text-lg">Radio Rythme Bleu est une radio associative.</strong> Elle n\'a pas d\'actionnaires, pas de dividendes à distribuer et elle a toujours refusé d’opter pour un statut commercial. C\'est aussi dans cet esprit qu\'elle a choisi d\'émettre, malgré des coûts de diffusion élevés, sur l’ensemble de la Nouvelle-Calédonie, même là où il n\'y a pas de contrepartie publicitaire.</p>' +
        '<p class="mt-3 text-base">Cela procède aussi d\'une volonté d\'assurer, aux côtés d\'autres radios, un nécessaire pluralisme sur l\'ensemble du territoire.</p>',
      img: rrb1999.src
    },
    {
      label: '????',
      content:
        '<p class="text-lg"><strong class="text-lg">Radio Rythme Bleu est la première radio de Nouvelle-Calédonie.</strong> Plusieurs enquêtes et sondages successifs la placent 1ère en audience cumulée, 1ère en durée d’écoute et 1ère en parts de marché !</p>' +
        '<p class="mt-3 text-base">Cette position de radio leader, RRB la doit à la variété de ses programmes, à l\'excellence de son information, à son investissement et à sa présence partout, pour tous et sur tous les terrains (politiques, économiques, sportifs, culturels, associatifs, religieux, vies des communes, fonctionnement des institutions…).</p>' +
        '<p class="mt-3 text-base">Elle le doit aussi à sa vocation assumée de radio de divertissement et de proximité pour tous les calédoniens (couleur musicale, dédicaces, anniversaires, humour, …). Les jeux participent également à cette réussite : sur Radio Rythme Bleu, il n\'y a pas de jours sans jeux ! ("Carte chance", rendez-vous SMS, Radio Stop…)</p>',
      img: illuRadio1999.src
    },
    {
      label: '2010',
      content:
        '<p class="text-lg"><strong class="text-lg">En 2010</strong> RRB lance son premier site Internet. Depuis, nous avons cessez de proposer de nouveaux types de contenus en ligne. Aujourd’hui, la rédaction alimente quotidiennement le site et nos réseaux sociaux en articles d’actualité et propose des podcasts des émissions.</p>',
      img: illuRadio2010.src
    },
    {
      label: '2016',
      content:
        '<p class="text-lg">Installée en 1985 dans des locaux sommaires dans le haut-Magenta, Radio Rythme Bleu a déménagé en 1991 pour s\'installer dans le centre-ville de Nouméa, avenue Foch.</p>' +
        '<p class="mt-3 text-base"><strong class="text-lg">En 2016 elle a intégré de nouveaux locaux rue de Sébastopol</strong>, avec des studios plus spacieux, mieux équipés, pour une qualité sans cesse renouvelée.</p>',
      img: ''
    }
  ];

  const Renderer = ({ item }) => {
    return (
      <div className="relative ">
        <div>
          <Image className="w-full aspect-[233/156] object-cover rounded-lg"
            src={item.img}
            width="466"
            height="312"
            alt={"Illustration de " + item.label}
            priority
          />
        </div>
        <h2 className="text-[60px] text-white font-bold absolute top-[18px] left-[18px]">{item.label}</h2>
        <div
          className="mt-6"
          dangerouslySetInnerHTML={{ __html: item.content }}>
        </div>
      </div>
    )
  }

  return (
    <Layout>
      <HeadMetadata
        title="L&apos;histoire de la radio"
        description="Radio Rythme Bleu est une radio généraliste qui allie au mieux information, musique, jeux et services. Elle est offerte au plus grand nombre dans toute la diversité ethnique, politique, sociale, culturelle et géographique de la Nouvelle-Calédonie."
      />

      <div className="px-4 sm:px-12 md:px-12 lg:px-12 xl:px-12 2xl:px-12">
        <Container>
          <Breadcrumbs entries={breadcrumb} />

          <div className="md:grid md:grid-cols-6 md:gap-6">
            <div className="col-start-1 col-end-6">
              <h1 className="mb-2 text-[40px] text-foreground-dark">L’histoire de la radio</h1>
              <p className='text-foreground-light mb-3'>Radio Rythme Bleu est une radio généraliste qui allie au mieux information, musique, jeux et services. Elle est offerte au plus grand nombre dans toute la diversité ethnique, politique, sociale, culturelle et géographique de la Nouvelle-Calédonie.</p>
            </div>

            <div className="col-start-6 relative justify-self-end">
              <SocialShare node={node} />
            </div>
          </div>

          <Separator className='mt-3 mb-12' />

        </Container>
      </div>
      <Carousel
        className="mb-8"
        setApi={setApi}
        opts={{
          align: "start",
          dragFree: true,
        }}
      >
        <div className="w-full overflow-hidden px-4 sm:px-12 md:px-12 lg:px-12 xl:px-12 2xl:px-12">
          {!isStart &&
            <div className="h-full absolute flex items-center z-10 left-16 2xl:left-52 bottom-5 scale-125 max-md:hidden">
              <CarouselPrevious />
            </div>
          }
          {!isEnd &&
            <div className="h-full absolute flex items-center z-10 right-32 bottom-5 scale-125 max-md:hidden">
              <CarouselNext />
            </div>
          }
          <div className="p-slider z-0">
            <CarouselContent overflowHidden={false}>
              <CarouselItem className="md:basis-[5%] lg:basis-[2%] mx-0 scale-125 max-md:basis-[0%] max-md:invisible">
                {isStart &&
                  <CarouselPrevious />
                }
              </CarouselItem>
              {
                storyContents.map((item, index) => (
                  <CarouselItem key={"node-team-" + index} className="basis-4/5 md:basis-2/5 group mx-2">
                    <Renderer item={item} />
                  </CarouselItem>
                ))
              }
              <CarouselItem className="md:basis-[5%] lg:basis-[2%] mx-0 scale-125 max-md:basis-[0%] max-md:invisible">
                {isEnd &&
                  <CarouselNext />
                }
              </CarouselItem>
            </CarouselContent>
          </div>
        </div>
      </Carousel>

      <div className="px-4 sm:px-12 md:px-12 lg:px-12 xl:px-12 2xl:px-12">
        <EquipeSlider nodes={teamMembers} />
      </div>

    </Layout>
  )
}

export async function getServerSideProps(context): Promise<GetStaticPropsResult<IndexPageProps>> {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=60, max-age=60'
  )

  const teamMembers: DrupalNode[] = await getTeamMembers(context);

  return {
    props: {
      teamMembers
    }
  }
}